import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface KbAutoSearchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** The agent's automatic knowledge-base search (`config.kbAutoSearch`, saved on Publish). */
export function KbAutoSearch({ checked, onChange }: KbAutoSearchProps) {
  return (
    <div className="flex items-start justify-between gap-4 pt-4 border-t">
      <div className="space-y-1">
        <Label htmlFor="kb-auto-search">Automatic search</Label>
        <p className="text-xs text-muted-foreground">
          Searches your knowledge bases while the caller speaks and gives the agent what matches before it answers.
          Calls that use it add $0.01/min.
        </p>
      </div>
      <Switch id="kb-auto-search" checked={checked} onCheckedChange={onChange} />
    </div>
  );
}
